// firebaseClient.ts
import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAPpBm1ttVbPd8Yn8sYqcW926vUobW27iw",
  authDomain: "xxxaoxxx-5a5eb.firebaseapp.com",
  projectId: "xxxaoxxx-5a5eb",
  storageBucket: "xxxaoxxx-5a5eb.firebasestorage.app",
  messagingSenderId: "123976243039",
  appId: "1:123976243039:web:b4aa52573f2cc91d6488ea",
  measurementId: "G-17T2S3QJFF"
};

// Initialize Firebase
export function getAppSingleton(){
    return getApps().length
    ? getApp()  
    : initializeApp(firebaseConfig);
}

// Services bound to the singleton app
export const app = getAppSingleton();
export const auth = getAuth(app);
export const db = getFirestore(app);